/* eslint-disable react/no-array-index-key */
import {
    type CmsButtonGrid,
    CmsButtonModelDiscriminator as getCmsButtonModelDiscriminator
} from 'autogen/swagger/all';
import CMSGrid from 'components/CMS/shared/CMSGrid';
import type { ReactNode } from 'react';
import { Button } from 'components/Button';
import CMSLinkButton from './components/CMSLinkButton';
import CMSSignupButton from './components/CMSSignupButton';
import CMSCustomButton from './components/CMSCustomButton';
import CMSLoginButton from './components/CMSLoginButton';
import CMSAdformButton from './components/CMSAdformButton';

export default function CMSButton({ model }: { model: CmsButtonGrid }) {
    const { size, buttons, desktopColumns, mobileColumns, alignment, fullWidth, isPreview } = model;

    if (!buttons.length && isPreview) {
        return <>Ingen knapper sat. Tilføj knapper for at generere forhåndsvisning.</>;
    }

    return (
        <CMSGrid
            columns={{ xs: mobileColumns, lg: desktopColumns }}
            alignment={alignment}
            fullWidth={fullWidth}
            gap={8}
        >
            {buttons.map((button, index) =>
                getCmsButtonModelDiscriminator<ReactNode>(
                    button,
                    (adformButtonModel) => {
                        const { variant, text } = adformButtonModel;

                        return (
                            <CMSAdformButton key={index} model={adformButtonModel} variant={variant} size={size}>
                                {text}
                            </CMSAdformButton>
                        );
                    },
                    (linkButtonModel) => {
                        const { link, variant, text } = linkButtonModel;
                        if (link) {
                            return (
                                <CMSLinkButton key={index} action={link} size={size} variant={variant}>
                                    {text}
                                </CMSLinkButton>
                            );
                        }
                    },
                    (signupButtonModel) => {
                        const { variant, text } = signupButtonModel;

                        return (
                            <CMSSignupButton key={index} variant={variant} size={size}>
                                {text}
                            </CMSSignupButton>
                        );
                    },
                    (loginButtonModel) => {
                        const { variant, text } = loginButtonModel;

                        return (
                            <CMSLoginButton key={index} variant={variant} size={size}>
                                {text}
                            </CMSLoginButton>
                        );
                    },
                    (noButtonModel) => {
                        const { explanation, variant } = noButtonModel;
                        if (isPreview) {
                            return (
                                <Button key={index} variant={variant} size={size}>
                                    {explanation}
                                </Button>
                            );
                        }
                        return null;
                    },
                    (customButtonModel) => {
                        const { variant, cssClasses, text } = customButtonModel;

                        return (
                            <CMSCustomButton key={index} variant={variant} size={size} className={cssClasses}>
                                {text}
                            </CMSCustomButton>
                        );
                    },
                    () => {
                        throw new Error('Invalid CMS button type');
                    }
                )
            )}
        </CMSGrid>
    );
}
